import {Injectable, OnInit} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {SharedValueService} from './shared-value.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from './authentication.service';

@Injectable()
export class PreLoginService implements OnInit {
   returnUrl: string;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private sharedValue: SharedValueService,
              private authService: AuthenticationService) { }
  ngOnInit() {
    this.returnUrl = this.activatedRoute.queryParams['returnUrl'] || '/';
  }
  prepare(authority: string): Observable<boolean> {
    return Observable.create(subscribe => {
      this.sharedValue.fetchUserSession().subscribe(value => {
        console.log('***', value);
        const userSession = this.sharedValue.getUserSession();
        switch (authority) {
          case 'auth':
            subscribe.next(true);
            subscribe.complete();
            break;
          case 'admin':
            subscribe.next(userSession.isAdmin || userSession.isOwner);
            subscribe.complete();
            break;
          default:
            this.router.navigate(['NotFound'], {replaceUrl: true});
            subscribe.next(false);
        }
      }, error => {
        subscribe.next(false);
        subscribe.error(error);
      });
    });
  }

  canActiveAuthority(authority: string, url: string): boolean | Observable<boolean> {
    if (this.sharedValue.isLoggedIn()) {
      return this.prepare(authority).map(res => {
        if (res) {
          return true;
        } else {
          this.router.navigate(['NotFound'], {replaceUrl: true});
          return false;
        }
      });
    } else {
      this.authService.redirectUrl = url;
      this.router.navigate(['/logout']);
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/pre-login.service.ts